import { Injectable } from '@angular/core';

import {
  PaxFormControlBase,
  PaxFormControlTextbox,
  PaxFormControlDatepicker,
  PaxFormControlRadio
} from './../../shared/index';

@Injectable()
export class FormMotorCarrierInformationService {

  getQuestions() {

    // todo: get data from store?
    let questions: PaxFormControlBase<any>[] = [

      // Carrier Name
      new PaxFormControlTextbox({
        key: 'carrierName',
        label: 'Motor Carrier Name',
        validation: [{
          name: 'required',
          condition: true,
          message: 'Field is required'
        }],
        order: 1
      }),

      // US DOT #
      new PaxFormControlTextbox({
        key: 'UsDotNumber',
        label: 'US DOT #',
        validation: [{
          name: 'required',
          condition: true,
          message: 'Field is required'
        }],
        order: 2
      }),

      // Date Lease Signed
      new PaxFormControlDatepicker({
        key: 'dateLeaseSigned',
        label: 'Date Lease Signed',
        validation: [{
          name: 'required',
          condition: true,
          message: 'Field is required'
        }],
        order: 3
      }),

      // Is it a permanent lease continuous renewable for 30 days or more?
      new PaxFormControlRadio({
        key: 'permanentLease',
        label: 'Is it a permanent lease continuous renewable for 30 days or more?',
        options: [
          { key: true, value: 'Yes' },
          { key: false, value: 'No' }
        ],
        validation: [{
          name: 'required',
          condition: true,
          message: 'Field is required'
        }],
        order: 4
      }),

      // Are you going to be covered under your trucking company's
      // liability coverage while you are going to, coming from and hauling a load?
      new PaxFormControlRadio({
        key: 'coveredUnderYourCoverage',
        label: `Are you going to be covered under your trucking company's
                liability coverage while you are going to, coming from and hauling a load?`,
        options: [
          { key: true, value: 'Yes' },
          { key: false, value: 'No' }
        ],
        validation: [{
          name: 'required',
          condition: true,
          message: 'Field is required'
        }],
        order: 5
      }),

      // Does your lease provide for exclusive possession and control?
      new PaxFormControlRadio({
        key: 'exclusivePossession',
        label: 'Does your lease provide for exclusive possession and control?',
        options: [
          { key: true, value: 'Yes' },
          { key: false, value: 'No' }
        ],
        validation: [{
          name: 'required',
          condition: true,
          message: 'Field is required'
        }],
        order: 6
      }),

      // Do you understand that this coverage does not apply to trip leasing?
      new PaxFormControlRadio({
        key: 'doesNotApplyToTripLeasing',
        label: 'Do you understand that this coverage does not apply to trip leasing?',
        options: [
          { key: true, value: 'Yes' },
          { key: false, value: 'No' }
        ],
        validation: [{
          name: 'required',
          condition: true,
          message: 'Field is required'
        }],
        order: 7
      }),

      // Do you understand that non trucking liability does not afford full time coverage
      // and does not provide liability insurance for you while you are going to, coming from and hauling a load?
      new PaxFormControlRadio({
        key: 'notFullTimeCoverage',
        label: `Do you understand that non trucking liability does not afford full time coverage
                and does not provide liability insurance for you while you are going to, coming from and hauling a load?`,
        options: [
          { key: true, value: 'Yes' },
          { key: false, value: 'No' }
        ],
        validation: [{
          name: 'required',
          condition: true,
          message: 'Field is required'
        }],
        order: 8
      }),

    ];

    return questions.sort((a, b) => a.order - b.order);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./resources/themes/pandax/bobtail/app/coverage-form/form-motor-carrier-information/form-motor-carrier-information.service.ts